module.exports = ".inline {\n  display: inline-block;\n  width: 45%;\n}\n\n.bottom {\n  position: absolute;\n  bottom: 0px;\n}\n\n.column {\n  margin: 0px;\n  /* background-color: blue; */\n}\n\n@media only screen and (max-width: 414px) {\n  .key {\n    /* background-color: green; */\n    text-align: center;\n    height: 100px;\n    width: 205px;\n    margin-top: 5px;\n    margin-right: 0px;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.css
// module id = ./src/app/components/admin/admin.component.css
// module chunks = main